const encumbrancesExcelModalSteps = {
  UPLOAD: 'upload',
  PREVIEW: 'preview',
  IMPORTING: 'importing',
} as const;

export type EncumbrancesExcelModalStep =
  (typeof encumbrancesExcelModalSteps)[keyof typeof encumbrancesExcelModalSteps];

export default encumbrancesExcelModalSteps;
